export default __webpack_public_path__ + "static/ISO-4de0cb3a4a003fd7b5c321263d8a2157.svg";